export default __webpack_public_path__ + "files/6efd17c7994b5efc8e161769ff95e803.png";